// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {createContext, useContext, useReducer} from 'react';
import type {i_toast_context, i_toast, i_toast_options,
    i_toast_config} from './types';

interface i_context extends i_toast_context {
    toasts: i_toast[];
    remove_toast: (id: string)=>void;
}

const Toast_context = createContext<i_context|null>(null);

type t_action =
    {type: 'ADD_TOAST', payload: i_toast, config?: i_toast_config} |
    {type: 'REMOVE_TOAST', payload: string} |
    {type: 'CLEAR_ALL'};

const reducer = (state: i_toast[], action: t_action): i_toast[]=>{
    switch (action.type)
    {
    case 'ADD_TOAST':
    {
        const new_state = [...state, action.payload];
        const max_toasts = action.config?.max_toasts;
        if (max_toasts && new_state.length > max_toasts)
            return new_state.slice(1);
        return new_state;
    }
    case 'REMOVE_TOAST':
        return state.filter(toast=>toast.id!==action.payload);
    case 'CLEAR_ALL':
        return [];
    default:
        return state;
    }
};

interface i_toast_provider_props {
    children: React.ReactNode;
    config?: i_toast_config;
}

export const Toast_provider = (props: i_toast_provider_props)=>{
    const {children, config = {}} = props;
    const [toasts, dispatch] = useReducer(reducer, []);
    const remove_toast = (id: string)=>
        dispatch({type: 'REMOVE_TOAST', payload: id});
    const toast = (options: i_toast_options)=>{
        const now = Date.now();
        const id = `toast_${now}_${Math.random().toString(36).substr(2, 9)}`;
        dispatch({
            type: 'ADD_TOAST',
            payload: {
                id,
                created_at: now,
                duration: 5000,
                pos: 'top-right',
                closeable: true,
                pause_on_hover: true,
                with_animation: true,
                ...options,
            },
            config,
        });
    };
    const clear = ()=>dispatch({type: 'CLEAR_ALL'});
    const value = {toast, clear, toasts, remove_toast, config};
    return <Toast_context.Provider value={value}>
      {children}
    </Toast_context.Provider>;
};

export const use_toast = ()=>{
    const context = useContext(Toast_context);
    if (!context)
        throw new Error('use_toast must be used within Toast_provider');
    return context;
};
